import { render, staticRenderFns } from "./DefineCostsDialog.vue?vue&type=template&id=0821f207"
import script from "./DefineCostsDialog.vue?vue&type=script&lang=ts"
export * from "./DefineCostsDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports